import {RoleManager} from "@/authorization/RoleManager";
import {CrudManager} from "@/scripts/ProfiControlRequests/CrudManager";
import {Login} from "@/model/Login"

export class AuthorizationRequests{
    
    public static Login(url:string, model:Login) : void
    {
        CrudManager.Post<string>(url, { UserName: model.UserName, Password: model.Password})
            .then(response => {
                this.ResetCredentials(model);
                model.PermissionMap = RoleManager.GeneratePermissionMap(response.data);
                model.Token = response.data;
            }).catch(_ => {
                model.HasError = true;
            });
    }
    
    private static ResetCredentials(model:Login) : void
    {
        model.UserName = '';
        model.Password = '';
    }
}